<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">{{title}}</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="max-height: 400px">

        <el-form ref="addForm">
          <div>
            <el-row >
              <el-col :span="24" class="item" v-for="(value,j) in CheckinAssessGroup" :key="j">
                <div class="CheckinAssessGroupTitle">
                  <h3>{{value.name}}</h3>
                </div>
                <el-form-item v-for="(item,i) in value.checkinAssessGroupDTOList" :key="i" :label="(i+1)+'、'+item.name+'（最高分：'+item.maxFraction+'分）'">
                  <el-radio-group v-model="itemCodeList[j][i]" style="width:100%;" @change="getSleep(value.name,item.name,item.checkinAssessItemList,value.checkinAssessClassCode,j,i)">
                    <el-radio v-for="item1 in item.checkinAssessItemList"
                              :key="item1.checkinAssessItemCode"
                              :label="item1.checkinAssessItemCode" style="width:90%;padding-bottom: 5px">{{item1.name}}（{{item1.fraction}}分）</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>

    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Add',
  props:[],
  data() {
    return {
      loading: false,

      title: '',
      itemCodeList:[],
      CheckinAssessGroup:'',

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        elderlyCode:'',
        checkinAssessClassCode:'',
        jsonArray:[],
        assessArr:[],
      },

    }

  },

  methods: {
    init(elderlyCode,elderlyName,checkinAssessClassCode){

      this.$refs.addForm.resetFields();

      this.addForm.elderlyCode=elderlyCode
      this.addForm.checkinAssessClassCode = checkinAssessClassCode;
      this.addForm.assessArr = [];

      this.title= '新建评估['+elderlyName+']';

      this.getList();

    },
    closeSelf() {
      this.$emit("closeSelectItem");
    },


    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinAssessGroup/GetListByClass",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              let list =response.data.data

              let arr = [];
              for(let i=0;i<list.length;i++){
                if(list[i].checkinAssessClassCode == this.addForm.checkinAssessClassCode){
                  arr.push(list[i]);
                }
              }

              this.CheckinAssessGroup = arr;

              this.itemCodeList=[]
              this.CheckinAssessGroup.forEach(element => {
                if(element){
                  this.itemCodeList.push([])
                }
              });

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },



    getSleep(valueName,itemName,list,code,j,i){

      if(this.addForm.assessArr[j]){
        this.addForm.assessArr[j].classCode=code
        this.addForm.assessArr[j].itemArrCode[i]=this.itemCodeList[j][i]
      }
      else{
        var item={classCode:code,itemArrCode:[]}
        item.itemArrCode[i]=this.itemCodeList[j][i]
        this.addForm.assessArr[j]=item
      }

    },

    confirm(){

      console.log(this.addForm.assessArr)

      if(this.addForm.assessArr.length<this.CheckinAssessGroup.length){
        this.$message({type: 'info', message: '您有选项未选择，请完成评估'});
        return

      }
      for(var i in this.addForm.assessArr){
        if(this.addForm.assessArr[i].itemArrCode.length<this.CheckinAssessGroup[i].checkinAssessGroupDTOList.length){
          this.$message({type: 'info', message: '您有选项未选择，请完成评估'});
          return
        }
      }

      for(var i2 in this.addForm.assessArr){
        let arr = this.addForm.assessArr[i2].itemArrCode;
        for(let k=0;k<arr.length;k++){
          if(arr[k] == null){
            this.$message({type: 'info', message: '您有选项未选择，请完成评估'});
            return
          }
        }
      }

      for(var i3 in this.addForm.assessArr){
        let arr = this.addForm.assessArr[i3].itemArrCode;
        for(let k=0;k<arr.length;k++){
          this.addForm.jsonArray.push({"checkinAssessItemCode":arr[k]});
        }
      }


      this.addSubmit();
    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyCheckinAssess/Add2",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;

            if (response.data.error == 0) {

              this.$emit("closeSelectItem");
              this.$emit("getListOut");
              this.$emit("closeOut");

            }else if(response.data.error == 1){
              this.addForm.assessArr=[]
              this.$message({type: 'info', message: response.data.message});
            }

          }
      )
    },


  }
}


</script>


<style lang="scss" scoped>


</style>
